import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../AnimationContents";
import { ButtonController } from "../Common/ButtonController";
import { LocalizationContents } from "../LocalizationContents";
import { GameLogic } from "../Logic/GameLogic";
import { GameModel } from "../Models/GameModel";

export class ErrorModal extends AnimationBaseController{
    $model: GameModel;
    constructor(
        @Inject private options: {closeCb: ()=>void},
        @Inject logic: GameLogic,
    ){
        super("ErrorModal");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return{
            animationContent: AnimationContents.ERROR_MODAL_JSON,
            libraryName: "modal_error",
            childControllers: {
                btn_exit: {
                    instanceName: "btn_exit_modal_error",
                    controller: ButtonController,
                    options: {
                        onClick: ()=>{
                            this.options.closeCb();
                        }
                    }
                },
                btn_restart: {
                    instanceName: "btn_restart_modal_error",
                    controller: ButtonController,
                    options: {
                        onClick: ()=>{
                            location.reload();
                        }
                    }
                }
            }
        }
    }

    protected onInitialize(): void {
        this.setTextStyleByQuery("text_error_modal", {valign: "middle"}, {});
        this.setTextVerticalAlignByQuery("text_error_modal", "middle");
        this.setTextByQuery("text_error_modal", LocalizationContents.getText("text_error"));
    }
}